import {
  CRM_GREEN_THEME_ID,
  DEV_GREEN_THEME_ID,
  MARKETING_RED_THEME_ID,
  PROJECTS_ORANGE_THEME_ID,
  WORKOS_IRIS_THEME_ID
} from "segments/segments-service";
import { SECONDARY_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { BLACK_COLOR_NAME } from "styles/color-consts";
import {
  CRM_PRODUCT_TYPE,
  MARKETER_PRODUCT_TYPE,
  PROJECTS_PRODUCT_TYPE,
  DEV_PRODUCT_TYPE,
  WORK_MANAGEMENT_PRODUCT_TYPE
} from "constants/products";

export default {
  cards: [
    {
      showOpen: true,
      isHighlighted: false,
      productType: WORK_MANAGEMENT_PRODUCT_TYPE,
      theme: WORKOS_IRIS_THEME_ID,
      header: {
        image: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/wm_main_logo.png",
          alt: "monday work-management logo"
        },
        mobileImage: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Work_management1.png",
          alt: "monday work-management logo"
        },
        subtitleText: ""
      },
      body: {
        bodyText: "Easily manage complex workflows, fuel collaborate, and plan initiatives at scale."
      },
      showDivider: true,
      useCases: {
        text: "Top use cases:",
        list: [
          { text: "No-code automations" },
          { text: "Integration with apps and tools" },
          { text: "Visual board views" },
          { text: "Lorem ipsum" }
        ]
      },
      buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true,
        color: BLACK_COLOR_NAME
      }
    },
    {
      showOpen: false,
      isHighlighted: false,
      productType: MARKETER_PRODUCT_TYPE,
      theme: MARKETING_RED_THEME_ID,
      header: {
        image: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/marketer_main_logo.png",
          alt: "monday marketer logo"
        },
        mobileImage: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Marketer1.png",
          alt: "monday marketer logo"
        },
        subtitleText: "Built on top of Work OS"
      },
      body: {
        bodyText: "Manage and collaborate on marketing and creative projects to launch effective campaigns."
      },
      showDivider: true,
      useCases: {
        text: "Top use cases:",
        list: [
          { text: "Campaign management" },
          { text: "Creative processes" },
          { text: "Digital asset management" },
          { text: "Event management" }
        ]
      },
      buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true,
        color: BLACK_COLOR_NAME,
        url: "https://monday.com/marketing"
      }
    },
    {
      showOpen: false,
      isHighlighted: false,
      productType: CRM_PRODUCT_TYPE,
      theme: CRM_GREEN_THEME_ID,
      header: {
        image: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/crm_main_logo.png",
          alt: "monday CRM logo"
        },
        mobileImage: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Sales_CRM1.png",
          alt: "monday CRM logo"
        },
        subtitleText: "Built on top of Work OS"
      },
      body: {
        bodyText: "Track and manage all aspects of your sales cycle, customer data, and more in one place."
      },
      showDivider: true,
      useCases: {
        text: "Top use cases:",
        list: [
          { text: "Lead management" },
          { text: "Deal management" },
          { text: "Post-sales management" },
          { text: "Account & contact management" }
        ]
      },
      buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true,
        color: BLACK_COLOR_NAME,
        url: "https://monday.com/crm"
      }
    },
    {
      showOpen: false,
      isHighlighted: false,
      productType: PROJECTS_PRODUCT_TYPE,
      theme: PROJECTS_ORANGE_THEME_ID,
      header: {
        image: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/projects_main_logo.png",
          alt: "monday projects logo"
        },
        mobileImage: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Project1.png",
          alt: "monday projects logo"
        },
        subtitleText: "Built on top of Work OS"
      },
      body: {
        bodyText: "Plan, collaborate, and execute on every project and portfolio to reach your goals, faster."
      },
      showDivider: true,
      useCases: {
        text: "Top use cases:",
        list: [
          { text: "Project management" },
          { text: "Project planning" },
          { text: "Portfolio management" },
          { text: "Project dashboards" }
        ]
      },
      buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true,
        color: BLACK_COLOR_NAME,
        url: "https://monday.com/project-management"
      }
    },
    {
      showOpen: false,
      isHighlighted: false,
      productType: DEV_PRODUCT_TYPE,
      theme: DEV_GREEN_THEME_ID,
      header: {
        image: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/dev_main_logo.png",
          alt: "monday dev logo"
        },
        mobileImage: {
          src:
            "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Dev1.png",
          alt: "monday dev logo"
        },
        subtitleText: "Built on top of Work OS"
      },
      body: {
        bodyText: "Easily build agile workflows to drive impact across your product, design, and R&D teams."
      },
      showDivider: true,
      useCases: {
        text: "Top use cases:",
        list: [
          { text: "Sprint planning" },
          { text: "Features and releases" },
          { text: "Bug tracking" },
          { text: "Sprint dashboards" }
        ]
      },
      buttonConfig: {
        buttonType: SECONDARY_BUTTON_TYPE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true,
        color: BLACK_COLOR_NAME,
        url: "https://monday.com/dev"
      }
    }
  ]
};
